# Route: /errors/access-denied
# Generic 403 landing page. The xp87-error-router.js helper redirects here
# when any page-level data fetch fails with a "403"-bearing error or when the
# scenario navigates to a feature-gated route that the tenant has not enabled.
# Permission: none (public — must render even when the user lacks scope)

page-error-access-denied:
  type: Page
  archetype: error
  meta:
    title: $t.errors.access_denied.meta_title
    route: /errors/access-denied
    layout: shell
    auth: stub
  spatial:
    display: flex
    direction: column
    gap: $spacing.xl
    padding: $spacing.xl
    overflow: auto
    align: center
    justify: center
    responsive:
      sm:
        padding: $spacing.md
        gap: $spacing.md
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - error-access-denied

# Top-level node — the scenario addresses it via
#   assert-visible: { node_id: error-access-denied }
# Body wording deliberately includes "not available" so the scenario's
#   wait-for-text { node_id: error-access-denied, text: "not available" }
# matches against the rendered en-US copy.
error-access-denied:
  type: ErrorState
  icon: $icon.warning
  title: $t.errors.access_denied.title
  content: $t.errors.access_denied.body
  action_label: $t.errors.access_denied.btn_home
  # Navigate to the dashboard rather than re-fetch page data. Without
  # action_route the emitted "Return to dashboard" button would call the
  # ErrorState's default _fetchPageData() retry handler, which this static
  # page does not define — so the click would throw.
  action_route: /today
  spatial:
    padding: $spacing.xl
    align: center
  tokens:
    background: $color_scheme.light.color.surface-elevated
    border: $border.default
    radius: $radius.md
    color: $color_scheme.light.color.on-surface
